import withPage from '@lib/page';
import PolicyPage from '@views/pages/policy';

export default withPage(PolicyPage);